import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../utils/common';
import type { S3Tree } from '../types/docsTypes';

// Async thunk to fetch manuals tree
export const fetchManualsTree = createAsyncThunk<S3Tree, { selectedCustomerName: string }, { rejectValue: string }>(
    'docs/fetchManualsTree',
    async ({ selectedCustomerName }, thunkAPI) => {
        try {
            const response = await axiosInstance.get<S3Tree>('trend/manuals/tree/', {
                headers: {
                    'customer': selectedCustomerName,
                },
            });
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Async thunk to get presigned URL for a file
export const fetchPresignedUrl = createAsyncThunk<{ url: string }, { key: string; selectedCustomerName: string }, { rejectValue: string }>(
    'docs/fetchPresignedUrl',
    async ({ key, selectedCustomerName }, thunkAPI) => {
        try {
            const response = await axiosInstance.get<{ url: string }>('trend/manuals/presign/', {
                params: { key },
                headers: {
                    'customer': selectedCustomerName,
                },
            });
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
